import type { UseMutationOptions } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import { ajaxFetch } from '~/helpers/api';
import { routes } from '~/helpers/routes';

type InputParams = {
  requestAccessCustomerId: number;
  formData: any;
};

type Options = Omit<UseMutationOptions<any, unknown, InputParams>, 'mutationKey' | 'mutationFn'>;

/**
 * Request RBAC access to a specific customer
 */
export const useCreateAccessRequestMutation = (options?: Options) => useMutation({
  mutationKey: [routes.v3.admin.agents.customerAccess],
  mutationFn: async ({ requestAccessCustomerId, formData }) => ajaxFetch(
    routes.v3.admin.agents.customerAccess,
    {
      method: 'POST',
      headers: { 'Content-type': 'application/json' },
      body: JSON.stringify({
        customer_id: requestAccessCustomerId,
        granted_by_agent_email: formData.approver_duration.approver,
        requested_minutes: parseInt(formData.approver_duration.duration, 10) * 1440, // convert days to minutes, 1440 minutes in a day
        requested_reason: formData.requested_reason,
        is_permanent: false,
      }),
    },
  ),
  ...options,
});
